/* eslint-disable @typescript-eslint/no-explicit-any */
import type { JSX, ReactNode } from 'react';
import React ,{ useState } from 'react';

import styled from 'styled-components';

import { DashboardWelcomeHeader } from '../Header/DashboardWelcomeHeader';
import FormHeader from './FormHeader';
import ReviewHeader from './ReviewHeader';

const MobileReviewFooter = styled.div`
  display: none;

  @media only screen and (max-width: 700px) {
    display: flex;
    width: 100%;
    padding-top: 12px;
  }
`;

interface WrapperProps {
  currentPage?: string;
  disableCardStyles?: boolean;
  hideCard?: boolean;
  customWidth?: string;
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  max-width: 90vw;
  flex-direction: column;
  align-items: ${({ currentPage }) =>
    currentPage === 'review' ? 'stretch' : 'center'};
  background-color: ${({ disableCardStyles }) =>
    disableCardStyles ? 'inherit' : 'transparent'};
  border-radius: 1px;
  border: 0;
  box-shadow: 0;
  width: ${({ customWidth }) =>
    customWidth ? customWidth : '100%'};

  visibility: ${({ hideCard }) =>
    hideCard ? 'hidden' : 'visible'};
  opacity: ${({ hideCard }) => (hideCard ? '0' : '1')};
  height: ${({ hideCard }) =>
    hideCard ? '0px' : 'auto'};
  ${({ hideCard }) =>
    hideCard
      ? 'transition: visibility 0s linear 0.33s, opacity 0.33s linear;'
      : 'transition-delay: 0s;'}
`;

interface FormCardProps {
  children?: ReactNode;
  cardId?: string | number;
  title?: string;
  subtitle?: React.ReactNode;
  image?: ReactNode;
  isReview?: boolean;
  fieldWrapper?: any;
  errorMustContain?: any;
  disableReviewHeader?: boolean;
  disableCardStyles?: boolean;
  hideCard?: boolean;
  customWidth?: string;
  welcomeTitle?: string;
}

function FormCard({
  children,
  cardId,
  title,
  subtitle,
  image,
  isReview,
  fieldWrapper,
  errorMustContain,
  disableReviewHeader,
  disableCardStyles,
  hideCard,
  customWidth,
  welcomeTitle
}: FormCardProps): JSX.Element {
  const currentPage =
    window.location.pathname?.split('/').reverse()[0];

  const [
    mobileReviewFooterDone,
    setMobileReviewFooterDone
  ] = useState<ReactNode | null>(null);

  return (
    <Wrapper
      currentPage={currentPage}
      disableCardStyles={disableCardStyles}
      hideCard={hideCard}
      customWidth={customWidth}
    >
      {isReview ? (
        !disableReviewHeader && (
          <ReviewHeader
            cardId={cardId}
            title={title}
            subtitle={subtitle}
            fieldWrapper={fieldWrapper}
            errorMustContain={errorMustContain}
            setMobileFooterDone={
              setMobileReviewFooterDone
            }
          />
        )
      ) : (
        <>
          {currentPage === 'dashboard' &&
            welcomeTitle && (
              <DashboardWelcomeHeader
                title={welcomeTitle}
                scroll={false}
              />
            )}

          <FormHeader
            cardId={cardId}
            title={title}
            subtitle={subtitle}
            image={image}
          />
        </>
      )}

      {children}

      {isReview &&
      !disableReviewHeader &&
      mobileReviewFooterDone ? (
        <MobileReviewFooter>
          {mobileReviewFooterDone}
        </MobileReviewFooter>
      ) : null}
    </Wrapper>
  );
}

export default FormCard;